export const POINTS_LARGE_ICON_WIDTH = 16;
export const POINTS_SMALL_ICON_WIDTH = 12;
